import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as supplierService from "../../services/supplierService";
import { DataTable, ProcBadge, amount, csvStamp, downloadCsv, orderKey } from "../Proc/procUi";
import { AppDropdown, EmptyState, LoadState, PageHeader, SecondaryButton, formatDate, pageStyle, useLoad } from "../../components/ui";

// The supplier's orders, from every buyer. A new order waits for an answer: accept it, or reject it with a reason.
const FILTERS = [
  { label: "All orders", value: null },
  { label: "Waiting for your answer", value: "3" },
  { label: "Accepted", value: "6" },
  { label: "Shipped", value: "8" },
  { label: "Out for delivery", value: "9" },
  { label: "Delivered", value: "10" },
  { label: "Completed", value: "15" },
  { label: "Rejected or cancelled", value: "4" },
];

export default function SupplierOrders() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const { data, loading, error, reload } = useLoad(() => supplierService.listOrders({ status }), [status]);
  const waiting = (data || []).filter((o) => o.status === 3).length;
  const exportCsv = () =>
    downloadCsv(`orders-${csvStamp()}.csv`, ["Order", "RFQ", "Title", "Buyer", "Status", "Currency", "Total", "Delivery date", "Invoices"], (data || []).map((o) => [o.order_number, o.rfq_number, o.rfq_title, o.buyer_name, o.status_label, o.currency, o.total, o.delivery_date || "", o.invoice_count || 0]));
  return (
    <div style={pageStyle}>
      <PageHeader title="Orders" subtitle={waiting && !status ? `${waiting} waiting for your answer` : "Orders your buyers placed with you"} actions={<SecondaryButton onClick={exportCsv} disabled={!(data || []).length}>Export CSV</SecondaryButton>} />
      <div className="mb-3" style={{ maxWidth: 280 }}>
        <AppDropdown id="sup-order-status" value={status} options={FILTERS} onChange={(e) => setStatus(e.value ?? null)} aria-label="Status" />
      </div>
      <LoadState loading={loading} error={error} onRetry={reload}>
        <DataTable
          rows={data || []}
          onRowClick={(o) => navigate(`/supplier/orders/${o.id}`)}
          empty={<EmptyState title={status ? "No orders with this status" : "No orders yet"} text="When a buyer awards you an RFQ, the order appears here and you get a notification." />}
          columns={[
            { label: "Order", render: (o) => <><div style={{ fontWeight: 600, color: "#111827" }}>{o.order_number}</div><div style={{ fontSize: 12, color: "#6B7280" }}>{o.rfq_number} · {o.rfq_title}</div></> },
            { label: "Buyer", render: (o) => o.buyer_name },
            { label: "Status", render: (o) => <ProcBadge status={orderKey(o.status)} label={o.status === 3 ? "Waiting for your answer" : o.status_label} /> },
            { label: "Total", render: (o) => `${o.currency} ${amount(o.total)}`, style: { whiteSpace: "nowrap" } },
            { label: "Delivery", render: (o) => (o.delivery_date ? formatDate(o.delivery_date) : "—") },
          ]}
        />
      </LoadState>
    </div>
  );
}
